import PropTypes from 'prop-types';
import React from 'react';

function HeaderHeading(props) {
  const { show, text, url } = props;
  if (!show) {
    return null;
  }

  return (
    <div className="ontheshow__header-heading">
      <div className="ontheshow__header-heading-bar" />
      <a href={url} className="ontheshow__header-heading-link">
        <h1 className="ontheshow__header-heading-text">{text}</h1>
      </a>
    </div>
  );
}

HeaderHeading.propTypes = {
  show: PropTypes.bool,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

HeaderHeading.defaultProps = {
  show: true,
};

export default HeaderHeading;
